import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";
const BASE_URL = process.env.REACT_APP_BASE_URL + '/infosite';


const getSupplierEnquiries = async ({ limit = 15, page = 0, status = null, sortModel = [], filterModel = [] }) => {
    try {
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        let search = null;
        if (filterModel['quickFilterValues']) {
            search = filterModel['quickFilterValues'][0] || null;
        }

        const response = await axiosGet(`${BASE_URL}/supplier/get`, {

            limit,
            page,
            sendStatus,
            search,
            sort: sortModel,

        });
        return response;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const getCareerEnquiries = async ({ limit = 15, page = 0, status = null, sortModel = [], filterModel = [] }) => {
    try {
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        let search = null;
        if (filterModel['quickFilterValues']) {
            search = filterModel['quickFilterValues'][0] || null;
        }

        const response = await axiosGet(`${BASE_URL}/career/get`, {

            limit,
            page,
            sendStatus,
            search,
            sort: sortModel,

        });
        return response;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const infositeAPI = {
    getSupplierEnquiries,
    getCareerEnquiries
}
export default infositeAPI;